import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { EmployeeHomeComponent } from './employee-home/employee-home.component';
import { EmployeeDetailComponent } from './employee-detail/employee-detail.component';


const routes: Routes = [
  { path: 'overview', component: EmployeeHomeComponent },
  { path: 'new', component: EmployeeDetailComponent},
  { path: ':id/detail', component:  EmployeeDetailComponent },
  { path: '', pathMatch: 'full', redirectTo: 'overview' }
];


@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EmployeeRoutingModule { }
